import { render, staticRenderFns } from "./edit-travel-policy-form.vue?vue&type=template&id=38acb0de&scoped=true&"
import script from "./edit-travel-policy-form.vue?vue&type=script&lang=js&"
export * from "./edit-travel-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acb0de",
  null
  
)

export default component.exports